import { z } from 'zod';

import { US_STATE_NAMES } from './practice.models';

// duplicated from the owning domain package (contracts stay domain-free);
// practice/application/src/enum-sync.ts asserts they stay in lockstep
export const IDENTIFIERS = ['CLIENT', 'PATIENT'] as const;
export const NOTE_FORMATS = ['BULLETED', 'NARRATIVE'] as const;
export const NOTE_LENGTHS = ['CONCISE', 'STANDARD'] as const;
export const LICENSE_TYPES = [
    'LPC',
    'LPCC',
    'LMHC',
    'LCPC',
    'LCSW',
    'LICSW',
    'LMSW',
    'LSW',
    'LMFT',
    'APCC',
    'AMFT',
    'ASW',
    'LPC-Associate',
    'MFT-Intern',
    'LP',
    'HSP',
    'LCP',
    'CADC',
    'LCADC',
    'LADC',
    'CAC',
    'PMHNP',
    'PMHCNS',
    'BCBA',
    'BCaBA',
    'QMHP',
] as const;
export const TAXONOMY_CODES = [
    '101YM0800X',
    '101YP2500X',
    '1041C0700X',
    '1041S0200X',
    '106H00000X',
    '106S00000X',
    '103T00000X',
    '103TC0700X',
    '103TA0400X',
    '103TB0200X',
    '171M00000X',
    '101Y00000X',
    '172V00000X',
    '225C00000X',
    '225XR0403X',
    '101YA0400X',
    '103TA0700X',
    '103TP0016X',
    '363LP0808X',
    '364SP0808X',
    '104100000X',
    '101YP1600X',
] as const;
export const NOTE_TEMPLATES = ['SOAP', 'NESSO'] as const;

export { treatmentApproachesSchema } from '@nesso/common-contracts/treatment-approaches';

export const noteFormatSchema = z.enum(NOTE_FORMATS);
export const noteLengthSchema = z.enum(NOTE_LENGTHS);
export const identifierSchema = z.enum(IDENTIFIERS);
export const licenseTypeSchema = z.enum(LICENSE_TYPES);
export const stateSchema = z.enum(US_STATE_NAMES);
export const taxonomyCodeSchema = z.enum(TAXONOMY_CODES);
export const noteTemplateSchema = z.enum(NOTE_TEMPLATES);

export const ONBOARDING_PREFERENCE_TYPE = 'onboarding' as const;

export const onboardingStepsSchema = z.enum([
    'name',
    'why',
    'format',
    'length',
    'identifier',
    'treatment',
    'ehr',
    'building',
]);

export const WELCOME_GUIDE_PREFERENCE_TYPE = 'welcome-guide' as const;

export const welcomeGuideTasksSchema = z.enum(['dictate-recap', 'record-session', 'review-note']);

export const GUIDANCE_PREFERENCE_TYPE = 'guidance' as const;

export const GUIDANCE_KEYS = [
    'note-copy-intro:SOAP',
    'note-copy-intro:NESSO',
    'telehealth-tab-sharing',
    'recap-session-guidance',
] as const;

export const guidanceKeySchema = z.enum(GUIDANCE_KEYS);

const EHR_PLATFORMS = [
    'ENSORA_HEALTH',
    'PRACTICE_BETTER',
    'SESSIONS_HEALTH',
    'SIMPLE_PRACTICE',
    'THERAPY_NOTES',
    'OTHER',
] as const;

export const ehrPlatformsSchema = z.enum(EHR_PLATFORMS);

export const WHY_INSIGHTS_TYPE = 'why' as const;
export const EHR_INSIGHTS_TYPE = 'ehr' as const;
